import { inject } from '@angular/core';
import { CanActivateChildFn } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { map, take } from 'rxjs';

/** Waits for the active locale catalog so imperative `translate()` in new routes uses the selected language. */
export const portalTranslationGuard: CanActivateChildFn = () => {
    const transloco = inject(TranslocoService);
    const lang = transloco.getActiveLang();

    return transloco.load(lang).pipe(
        take(1),
        map(() => true)
    );
};
